import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/loja`;
const LojaCtx = createContext(null);

export const LojaProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('loja_token'));
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem('loja_cart') || '[]'); } catch { return []; }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => { localStorage.setItem('loja_cart', JSON.stringify(cart)); }, [cart]);

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setUser(r.data))
      .catch(() => { setToken(null); localStorage.removeItem('loja_token'); });
  }, [token]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem('loja_token', r.data.access_token);
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (name, email, password, phone) => {
    const r = await axios.post(`${API}/auth/register`, { name, email, password, phone });
    localStorage.setItem('loja_token', r.data.access_token);
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem('loja_token');
    setToken(null); setUser(null); setCart([]);
  };

  const addToCart = (product, qty = 1) => {
    setCart(prev => {
      const idx = prev.findIndex(i => i.product_id === product.id);
      if (idx >= 0) {
        const copy = [...prev]; copy[idx].quantity += qty; return copy;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          image_url: product.image_url,
          quantity: qty,
          metadata: product.metadata || {},
        },
      ];
    });
  };
  const removeFromCart = (product_id) => setCart(prev => prev.filter(i => i.product_id !== product_id));
  const updateQty = (product_id, quantity) => setCart(prev => prev.map(i => i.product_id === product_id ? { ...i, quantity: Math.max(1, quantity) } : i));
  const clearCart = () => setCart([]);

  const authHeaders = () => token ? { Authorization: `Bearer ${token}` } : {};
  const cartTotal = cart.reduce((s, i) => s + i.price * i.quantity, 0);
  const cartCount = cart.reduce((s, i) => s + i.quantity, 0);

  return (
    <LojaCtx.Provider value={{ user, token, loading, setLoading, login, register, logout, cart, addToCart, removeFromCart, updateQty, clearCart, cartTotal, cartCount, authHeaders, API }}>
      {children}
    </LojaCtx.Provider>
  );
};

export const useLoja = () => {
  const ctx = useContext(LojaCtx);
  if (!ctx) throw new Error('useLoja must be used within LojaProvider');
  return ctx;
};
